export default {
    common: {
        title: 'Kết quả buổi học',
    },
    studentResult: {
        subtitle: 'Hãy xem lại những gì đã học nhé!',
        totalActivities: 'Tổng cộng đã thực hiện { count } hoạt động!',
    },
    teacherResult: {
        sessionInfo: 'Thông tin buổi học',
        sessionInfoItem: {
            title: 'Thông tin cơ bản về buổi học',
            date: 'Ngày',
            duration: 'Thời gian thực hiện',
            studentCount: 'Số người tham gia',
            curriculum: 'Tiểu mục',
        },
        noModules: 'Không có hoạt động nào được thực hiện.',
        showMvp: 'Công bố MVP',
    },
};
